import { takeEvery, fork, put, all, call } from "redux-saga/effects"
import toastr from "toastr";

// Login Redux States
import {
  ADD_PARTICIPANTS_INVITES,
  EDIT_PARTICIPANTS_INVITES,
  VIEW_PARTICIPANTS_INVITES,
  LIST_PARTICIPANTS_INVITES,
  DELETE_PARTICIPANTS_INVITES,
  ADD_PARTICIPANTS_INVITES_TEXT,
  EDIT_PARTICIPANTS_INVITES_TEXT,
  VIEW_PARTICIPANTS_INVITES_TEXT,
  LIST_PARTICIPANTS_INVITES_TEXT,
  DELETE_PARTICIPANTS_INVITES_TEXT
} from "./actionTypes"
import { participantsInvitesSuccess, participantsInvitesError } from "./actions"

import {
  onAddParticipantsInvites,
  onEditParticipantsInvites,
  onViewParticipantsInvites,
  onListParticipantsInvites,
  onDeleteParticipantsInvites,
  onAddParticipantsInvitesText,
  onEditParticipantsInvitesText,
  onListParticipantsInvitesText,
  onViewParticipantsInvitesText,
  onDeleteParticipantsInvitesText
} from "helpers/backend_api_helper";

// add Invites
function* addParticipantsInvites({ payload: { data, history, callback } }) {
  try {
    const response = yield call(onAddParticipantsInvites, data);
    yield put(participantsInvitesSuccess(response));
    callback && callback(response);
  } catch (error) {
    yield put(participantsInvitesError(error?.response?.data?.message || "Server Error"));
  }
}

// edit Invites
function* ParticipantseditInvites({ payload: { data, id, callback } }) {
  try {
    const response = yield call(onEditParticipantsInvites, data, id);
    yield put(participantsInvitesSuccess(response));
    callback && callback(response);

  } catch (error) {
    yield put(participantsInvitesError(error?.response?.data?.message || "Server Error"));
  }
}

// list Invites
function* listParticipantsInvites({ payload: { data, callback } }) {
  try {
    const response = yield call(onListParticipantsInvites, data);
    yield put(participantsInvitesSuccess(response));
    callback && callback(response);

  } catch (error) {
    yield put(participantsInvitesError(error?.response?.data?.message || "Server Error"));
  }
}

// view Invites
function* ParticipantsviewInvites({ payload: { data, history } }) {
  try {
    const response = yield call(onViewParticipantsInvites, data);
    yield put(participantsInvitesSuccess(response));

  } catch (error) {
    yield put(participantsInvitesError(error?.response?.data?.message || "Server Error"));
  }
}

// delete Invites
function* deleteParticipantsInvites({ payload: { data, callback } }) {
  try {
    const response = yield call(onDeleteParticipantsInvites, data);
    yield put(participantsInvitesSuccess(response));

    callback && callback(response);
  } catch (error) {
    yield put(participantsInvitesError(error?.response?.data?.message || "Server Error"));
  }
}


// text
// add Invites
function* addAspirationText({ payload: { data, history, callback } }) {
  try {
    const response = yield call(onAddParticipantsInvitesText, data);
    yield put(participantsInvitesSuccess(response));
    callback && callback(response);
  } catch (error) {
    toastr.error(error?.response?.data?.message);
    yield put(participantsInvitesError(error?.response?.data?.message || "Server Error"));
  }
}

// edit Invites
function* ParticipantseditInvitesText({ payload: { data, id, callback } }) {
  try {
    const response = yield call(onEditParticipantsInvitesText, data, id);
    yield put(participantsInvitesSuccess(response));
    callback && callback(response);

  } catch (error) {
    yield put(participantsInvitesError(error?.response?.data?.message || "Server Error"));
  }
}

// list Invites
function* listParticipantsInvitesText({ payload: { data, id, callback } }) {
  try {
    const response = yield call(onListParticipantsInvitesText, data, id);
    yield put(participantsInvitesSuccess(response));
    callback && callback(response);

  } catch (error) {
    yield put(participantsInvitesError(error?.response?.data?.message || "Server Error"));
  }
}

// view Invites
function* viewAspirationText({ payload: { data, history } }) {
  try {
    const response = yield call(onViewParticipantsInvitesText, data);
    yield put(participantsInvitesSuccess(response));

  } catch (error) {
    yield put(participantsInvitesError(error?.response?.data?.message || "Server Error"));
  }
}

// delete Invites
function* deleteAspirationText({ payload: { data, callback } }) {
  try {
    const response = yield call(onDeleteParticipantsInvitesText, data);
    yield put(participantsInvitesSuccess(response));

    callback && callback(response);
  } catch (error) {
    yield put(participantsInvitesError(error?.response?.data?.message || "Server Error"));
  }
}



function* InvitesSaga() {
  yield takeEvery(ADD_PARTICIPANTS_INVITES, addParticipantsInvites);
  yield takeEvery(EDIT_PARTICIPANTS_INVITES, ParticipantseditInvites);
  yield takeEvery(LIST_PARTICIPANTS_INVITES, listParticipantsInvites);
  yield takeEvery(VIEW_PARTICIPANTS_INVITES, ParticipantsviewInvites);
  yield takeEvery(DELETE_PARTICIPANTS_INVITES, deleteParticipantsInvites);

  // text
  yield takeEvery(ADD_PARTICIPANTS_INVITES_TEXT, addAspirationText);
  yield takeEvery(EDIT_PARTICIPANTS_INVITES_TEXT, ParticipantseditInvitesText);
  yield takeEvery(LIST_PARTICIPANTS_INVITES_TEXT, listParticipantsInvitesText);
  yield takeEvery(VIEW_PARTICIPANTS_INVITES_TEXT, viewAspirationText);
  yield takeEvery(DELETE_PARTICIPANTS_INVITES_TEXT, deleteAspirationText);
}

export default InvitesSaga;

